import styled, { css, DefaultTheme } from 'styled-components'
import { Link } from 'react-router-dom'

// Types
export type Variants = 'primary' | 'secondary' | 'tertiary'

interface GetColorArgs {
  variant: Variants
  theme: DefaultTheme
  hover?: boolean
}

// Helpers
const getColor = ({ variant, theme, hover = false }: GetColorArgs) => {
  const colors = {
    primary: theme.colors.primaryTint[100],
    secondary: theme.colors.foreground.secondary[1],
    tertiary: theme.colors.foreground.secondary[3],

    hover: {
      primary: theme.colors.primaryTint[70],
      secondary: theme.colors.foreground.secondary[4],
      tertiary: theme.colors.foreground.secondary[4],
    },
  }

  if (hover) {
    return colors.hover[variant]
  }

  return colors[variant]
}

const baseLinkStyle = css<{
  $variant: Variants
  $isUnderlined: boolean
}>(
  ({ theme, $isUnderlined, $variant }) => css`
    color: ${getColor({ theme, variant: $variant })};
    font-weight: 600;
    text-decoration: ${$isUnderlined ? 'underline' : undefined};
    cursor: pointer;

    :hover {
      color: ${getColor({ theme, variant: $variant, hover: true })};
    }
  `
)

export const InternalLink = styled(Link)<{
  $variant: Variants
  $isUnderlined: boolean
}>`
  ${baseLinkStyle}
`

export const ExternalLink = styled.a<{
  $variant: Variants
  $isUnderlined: boolean
}>`
  ${baseLinkStyle}
`
